import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const color = {
  blue: "",
  sky: "",
  skyBlue: "",
  green: "",
  gold: "",
  yellow: "",
  gray: "",
  red: ""
}, tagVariants = tv({
  base: "inline-flex rtl:flex-row-reverse items-center justify-center rounded-md gap-2 whitespace-nowrap overflow-hidden select-none",
  variants: {
    size: {
      sm: "text-xs h-[20px] px-[6px] py-[2px]",
      default: "text-[0.8571rem] h-[24px] px-[8px] py-[4px]",
      lg: ""
    },
    variant: {
      solid: "",
      filled: "",
      outlined: "border",
      filledBorder: "border"
    },
    color,
    bgColor: color,
    textColor: color
  },
  compoundVariants: [
    // solid
    { variant: "solid", bgColor: "blue", class: "bg-(--blue-9)" },
    { variant: "solid", bgColor: ["sky", "skyBlue"], class: "bg-(--sky-blue-9)" },
    { variant: "solid", bgColor: "green", class: "bg-(--green-9)" },
    { variant: "solid", bgColor: "gold", class: "bg-(--gold-3-alpha)" },
    { variant: "solid", bgColor: "yellow", class: "bg-(--yellow-9)" },
    { variant: "solid", bgColor: "gray", class: "bg-(--gray-primary-1)" },
    { variant: "solid", bgColor: "red", class: "bg-(--red-9)" },
    { variant: "solid", textColor: "blue", class: "text-(--pure-white)" },
    { variant: "solid", textColor: ["sky", "skyBlue"], class: "text-(--pure-black)" },
    { variant: "solid", textColor: "green", class: "text-(--pure-white)" },
    { variant: "solid", textColor: "gold", class: "text-(--black)" },
    { variant: "solid", textColor: "yellow", class: "text-(--pure-black)" },
    { variant: "solid", textColor: "gray", class: "text-(--pure-white)" },
    { variant: "solid", textColor: "red", class: "text-(--pure-white)" },
    // filled
    { variant: "filled", bgColor: "blue", class: "bg-(--blue-3-alpha)" },
    { variant: "filled", bgColor: ["sky", "skyBlue"], class: "bg-(--sky-blue-3-alpha)" },
    { variant: "filled", bgColor: "green", class: "bg-(--green-3-alpha)" },
    { variant: "filled", bgColor: "gold", class: "bg-(--gold-3-alpha)" },
    { variant: "filled", bgColor: "yellow", class: "bg-(--yellow-3-alpha)" },
    { variant: "filled", bgColor: "gray", class: "bg-(--gray-tag-1-alpha)" },
    { variant: "filled", bgColor: "red", class: "bg-(--red-3-alpha)" },
    { variant: "filled", textColor: "blue", class: "text-(--blue-11-alpha) dark:text-(--blue-11)" },
    { variant: "filled", textColor: ["sky", "skyBlue"], class: "text-(--sky-blue-11)" },
    { variant: "filled", textColor: "green", class: "text-(--green-11-alpha)" },
    { variant: "filled", textColor: "gold", class: "text-(--gold-11-alpha)" },
    { variant: "filled", textColor: "yellow", class: "text-(--yellow-12-alpha)" },
    { variant: "filled", textColor: "gray", class: "text-(--gray-text-1-alpha)" },
    { variant: "filled", textColor: "red", class: "text-(--red-11)" },
    // outlined
    { variant: "outlined", color: "blue", class: "border-(--blue-8-alpha) dark:border-(--blue-8) text-(--blue-11-alpha) dark:text-(--blue-11)" },
    { variant: "outlined", color: ["sky", "skyBlue"], class: "border-(--sky-blue-8-alpha) text-(--sky-blue-11)" },
    { variant: "outlined", color: "green", class: "border-(--green-8-alpha) text-(--green-11-alpha)" },
    { variant: "outlined", color: "gold", class: "border-(--gold-8-alpha) text-(--gold-11-alpha)" },
    { variant: "outlined", color: "yellow", class: "border-(--yellow-8-alpha) text-(--yellow-12-alpha)" },
    { variant: "outlined", color: "gray", class: "border-(--gray-border-1-alpha) text-(--gray-text-1-alpha)" },
    { variant: "outlined", color: "red", class: "border-(--red-8-alpha) text-(--red-11)" },
    // filledBorder
    {
      variant: "filledBorder",
      color: "blue",
      class: "border-(--blue-7-alpha) bg-(--blue-2-alpha) text-(--blue-11-alpha) dark:border-(--blue-7) dark:bg-(--blue-2) dark:text-(--blue-11)"
    },
    { variant: "filledBorder", color: ["sky", "skyBlue"], class: "border-(--sky-blue-7-alpha) bg-(--sky-blue-2-alpha) text-(--sky-blue-11)" },
    { variant: "filledBorder", color: "green", class: "border-(--green-7-alpha) bg-(--green-2-alpha) text-(--green-11-alpha)" },
    { variant: "filledBorder", color: "gold", class: "border-(--gold-7-alpha) bg-(--gold-2-alpha) text-(--gold-11-alpha)" },
    { variant: "filledBorder", color: "yellow", class: "border-(--yellow-7-alpha) bg-(--yellow-2-alpha) text-(--yellow-12-alpha)" },
    { variant: "filledBorder", color: "gray", class: "border-(--gray-border-2-alpha) bg-(--white) text-(--gray-text-1-alpha)" },
    { variant: "filledBorder", color: "red", class: "border-(--red-7-alpha) bg-(--red-2-alpha) text-(--red-11-alpha)" }
  ],
  defaultVariants: {
    size: "default",
    variant: "filled",
    color: "gray",
    bgColor: "gray",
    textColor: "gray"
  }
});
export {
  tagVariants
};
//# sourceMappingURL=index.js.map
